import emailjs from '@emailjs/browser';

// ⚠️ Tus credenciales reales de EmailJS
const SERVICE_ID = 'service_kdfys3f'; 
const TEMPLATE_ID_RECIBOS = 'template_jqmh37b'; // Plantilla para los recibos de mantenimiento
const TEMPLATE_ID_NOTIFICACIONES = 'template_dqh1wim'; // 👈 Pega aquí el ID de tu nueva plantilla creada para comunicados
const PUBLIC_KEY = 'pfJqVpoChzMWTp7L9'; 

export const enviarCorreoRecibo = async (
  correo,
  nombre,
  numeroReciboRef,
  mesRecibo,
  anioRecibo,
  montoCuota,
  fechaEmision,
  fechaVencimiento
) => {
  try {
    const templateParams = {
      to_email: correo,
      to_name: nombre,
      numero_recibo: numeroReciboRef,
      mes_recibo: mesRecibo || 'No especificado',
      anio_recibo: anioRecibo || '',
      fecha_emision: fechaEmision || 'No especificada',
      fecha_vencimiento: fechaVencimiento || 'No especificada',
      monto: montoCuota
    };

    const respuesta = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID_RECIBOS, // Usamos la plantilla de recibos
      templateParams,
      PUBLIC_KEY
    );

    console.log('Correo enviado exitosamente:', respuesta.status, respuesta.text);
    return true;
  } catch (error) {
    console.error('Error al enviar el correo con EmailJS:', error);
    throw error;
  }
};

// FUNCIÓN DE NOTIFICACIONES Y COMUNICADOS GENERALES
export const enviarCorreoNotificacion = async (
  correoDestino,
  nombrePropietario,
  tituloAviso,
  mensajeAviso,
  nombreEdificio
) => {
  try {
    const templateParams = {
      to_email: correoDestino,
      to_name: nombrePropietario,
      titulo_aviso: tituloAviso,
      mensaje_aviso: mensajeAviso,
      nombre_edificio: nombreEdificio
    };

    const respuesta = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID_NOTIFICACIONES, // 👈 Aquí utilizamos la nueva plantilla exclusiva para avisos
      templateParams,
      PUBLIC_KEY
    );

    console.log('Notificación enviada exitosamente:', respuesta.status, respuesta.text);
    return true;
  } catch (error) {
    console.error('Error al enviar la notificación con EmailJS:', error);
    throw error;
  }
};